export default __webpack_public_path__ + "static/media/browser2.9eb6de5f.png";